import {  Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CustomerNotesViewModel, CustomerNotesSearchItem } from './customer-notes.model';
import { catchError } from 'rxjs/operators';
import { CustomErrorHandlers } from '../../shared/CustomErrorHandlers';
import { Tuple } from '../../entities';

@Injectable()
export class CustomerNotesService {
  constructor(private _http: HttpClient, private errorHandler: CustomErrorHandlers) {
  }
  public GetAllCustomerNotes(): Observable<CustomerNotesViewModel[]> {
    return this._http.get<CustomerNotesViewModel[]>('api/CustomerNotes/GetAllCustomerNotes').pipe(catchError(this.errorHandler.handleError));
  }

  public GetCustomerNotesBySearchItem(searchItem: CustomerNotesSearchItem): Observable<CustomerNotesViewModel[]> {
    return this._http.post<CustomerNotesViewModel[]>('api/CustomerNotes/GetCustomerNotesBySearchParam', searchItem).pipe(catchError(this.errorHandler.handleError));
  }

  public SaveCustomerNote(model: CustomerNotesViewModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/CustomerNotes/PostCustomerNotes', model).pipe(catchError(this.errorHandler.handleError));
  }


  public UpdateCustomerNote(model: CustomerNotesViewModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/CustomerNotes/UpdateCustomerNote', model).pipe(catchError(this.errorHandler.handleError));
  }


}
